import type {
  NonProspectDomainsUpdateDto,
  NonProspectDomainCsvPreviewDto,
  NonProspectDomainsScope,
  NonProspectDomainsViewDto,
} from '@/types/nonProspectDomains'
import { apiClient, type ApiResponse } from './client'

/**
 * Non-prospect email domains (ORB-619). Two sub-resources returning the same shape — the standing
 * set on a client company and the per-workspace set — so one editor component drives both.
 * Deliberately separate from `/Tracking`, which carries the visitor-tracking origin allowlist.
 */
export const nonProspectDomainsApi = {
  getForCompany: (clientCompanyId: string): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/NonProspectDomains`),

  patchForCompany: (
    clientCompanyId: string,
    dto: NonProspectDomainsUpdateDto,
  ): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.patch(`/api/ClientCompanies/${clientCompanyId}/NonProspectDomains`, dto),

  getForWorkspace: (
    clientCompanyId: string,
    workspaceId: string,
  ): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/NonProspectDomains`),

  patchForWorkspace: (
    clientCompanyId: string,
    workspaceId: string,
    dto: NonProspectDomainsUpdateDto,
  ): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.patch(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/NonProspectDomains`, dto),
}

/** The browser sends the file intact; parsing and skip decisions are made by the API. */
export function previewNonProspectDomains(scope: NonProspectDomainsScope, file: File, column?: number) {
  const form = new FormData()
  form.append('file', file)
  const base = `/api/ClientCompanies/${encodeURIComponent(scope.clientCompanyId)}`
  const level = scope.level === 'workspace' ? `/Workspaces/${encodeURIComponent(scope.workspaceId)}` : ''
  const query = column === undefined ? '' : `?column=${column}`
  return apiClient.post<NonProspectDomainCsvPreviewDto>(`${base}${level}/NonProspectDomains/Preview${query}`, form)
}
